import { type HttpGet } from '@/shared/infra/http'
import type {
  PersonalNotificationPreferences,
  LoadPersonalNotificationPreferences,
} from '@/shared/domain'

type PersonalNotificationPreferencesResponse = { preferences: PersonalNotificationPreferences }

export class SupabaseLoadPersonalNotificationPreferencesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadPersonalNotificationPreferences = async () => {
    const response = await this.http.get<PersonalNotificationPreferencesResponse>({
      url: '/users/notification-preferences/personal',
    })
    return { preferences: response.preferences }
  }
}
